import React, {useEffect, useState} from "react";
import localization from "assets/localization/localization";
import {Button} from "react-bootstrap";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import '../main.css'
import Layout from 'components/sales/layout/layout';
import { ToastContainer, toast } from "react-toastify";
import DropDownInput from "../../../components/sales/Input/dropDownInput/dropDownInput";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import {salaryByPhone} from "../../../services/redux/Valet/Project/action";

const MasterSalaryPenalty = ({
                                 masterSalaryPenaltyRequest,
                                 masterSalaryPenaltyResponse = [],
                                 documentUploadUrlPublic,
                                 documentUrlDataPublic = [],
                                 salaryByPhone,
                                 salaryByPhoneResponse = []
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [inputList, setInputList] = useState(
        [{phone_no: '', subcategory: '', remark: '', urls: ''}]
    );

    const [salaryId, setSalaryId] = useState(null);
    const handleInputValue = (val, key) => {
        const list = [...inputList];
        list[0][key] = val;
        setInputList([...list]);
    };

    const handleOnSubmitForm = async () => {
        let inputValues = inputList[0]
        setIsLoading(true)
        await masterSalaryPenaltyRequest(inputValues)
        setIsLoading(false)
    }


    useEffect(() => {
        if(parseInt(masterSalaryPenaltyResponse?.status) === 200){
            toast.success(masterSalaryPenaltyResponse?.message)
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } else if(parseInt(masterSalaryPenaltyResponse?.status) === 400){
            toast.error(masterSalaryPenaltyResponse?.message);
        }
    }, [masterSalaryPenaltyResponse]);

    const handleSearchSalary = async () => {
        setIsLoading(true);
        await salaryByPhone(inputList[0].phone_no);
        setIsLoading(false);
    }

    useEffect(() => {
        if(parseInt(salaryByPhoneResponse?.status) === 200){
            toast.success(salaryByPhoneResponse?.message)
        } else if(parseInt(salaryByPhoneResponse?.status) === 400){
            toast.error(salaryByPhoneResponse?.message);
        }
    }, [salaryByPhoneResponse])

    useEffect(() => {
        if(salaryByPhoneResponse && salaryByPhoneResponse?.data && salaryByPhoneResponse?.data[0]){
            handleInputValue(salaryByPhoneResponse?.data[0]?.id, 'salary_id')
        }
    }, [salaryByPhoneResponse]);
    return (
        <>
            <Layout isGoback isLoading={isLoading}>
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            {"Suggest Penalty"}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="d-flex col-md-12">
                                    <div className="col-md-6">
                                        <ConstantInput
                                            label={'Phone No'}
                                            type="text"
                                            value={inputList.phone_no}
                                            handleChange={(val) => {
                                                handleInputValue(val, 'phone_no');
                                            }}
                                            required
                                            maxLength={10}
                                            isStarRequired={true}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <center><Button onClick={handleSearchSalary}>
                                            Search
                                        </Button>
                                        </center>
                                    </div>
                                </div>
                                {salaryByPhoneResponse?.data && salaryByPhoneResponse?.data[0] &&
                                    <>
                                        <div className="col-md-12">
                                            <ConstantInput
                                                label={'Name'}
                                                type="text"
                                                value={salaryByPhoneResponse?.data[0]?.user_name}
                                                required
                                                isStarRequired={true}

                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <DropDownInput

                                                data={[
                                                    {
                                                        id: 'Hygiene & Uniform Violation',
                                                        name: 'Hygiene & Uniform Violation'
                                                    },
                                                    {id: 'Late Arrival', name: 'Late Arrival'},
                                                    {id: 'Shift Violation', name: 'Shift Violation'},
                                                    {id: 'Sudden Leave', name: 'Sudden Leave'},
                                                    {id: 'Absconding', name: 'Absconding'}
                                                ]}
                                                label={'Penalty Type'}
                                                required
                                                isStarRequired={true}
                                                getIdValue={(val) => {
                                                    handleInputValue(val.id, 'subcategory');
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <ConstantInput
                                                label={'Remark'}
                                                type="text"
                                                value={inputList.remark}
                                                handleChange={(val) => {
                                                    handleInputValue(val, 'remark');
                                                }}
                                                required
                                                isStarRequired={true}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <FileUpload
                                                id={"addAttachment"}
                                                accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                documentUploadUrl={documentUploadUrlPublic}
                                                documentUrlData={documentUrlDataPublic}
                                                onChange={(val) =>
                                                    handleInputValue(val, 'urls')
                                                }
                                                multiple={true}
                                            >
                                    <span className="btn btn-transparent">
                                        {"Urls"}
                                    </span>
                                            </FileUpload>
                                        </div>
                                        <div className="col-md-12">
                                            <center><Button onClick={handleOnSubmitForm}>
                                                {localization.submitDtl}
                                            </Button>
                                            </center>
                                        </div>
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default MasterSalaryPenalty
